/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
import { AwardedLaneListItemFragmentDoc } from './AwardedLaneListItemFragment'
export type IAwardedLaneFragment = { __typename?: 'ShipperRate' } & Pick<
  Types.IShipperRate,
  | 'id'
  | 'carrierMarketRate'
  | 'datMiles'
  | 'shipperLaneId'
  | 'volume'
  | 'volumeType'
  | 'deliveryCity'
  | 'deliveryStateCode'
  | 'deliveryRegion'
  | 'endDate'
  | 'isDeliveryDropTrailer'
  | 'isPickupDropTrailer'
  | 'pickupCity'
  | 'pickupStateCode'
  | 'pickupRegion'
  | 'sourcedCarrierRatesCount'
  | 'sourceStatus'
  | 'startDate'
  | 'weeklyVolume'
> & {
    listingDetails?: Types.Maybe<
      { __typename?: 'ShipperRateListingDetails' } & Pick<
        Types.IShipperRateListingDetails,
        'id' | 'commodity' | 'maxWeight' | 'minWeight' | 'note' | 'offerLeadTime'
      >
    >
    rate?: Types.Maybe<{ __typename?: 'Rate' } & Pick<Types.IRate, 'id' | 'amount' | 'rateTypeKey'>>
    requestForProposalLaneFeedback?: Types.Maybe<
      { __typename?: 'RequestForProposalLaneFeedback' } & Pick<
        Types.IRequestForProposalLaneFeedback,
        'id' | 'tttAtAward'
      > & {
          requestForProposalLanePrice: { __typename?: 'RequestForProposalLanePrice' } & Pick<
            Types.IRequestForProposalLanePrice,
            'id' | 'tfxhAllIn'
          > & {
              requestForProposalLane: { __typename?: 'RequestForProposalLane' } & Pick<
                Types.IRequestForProposalLane,
                'id'
              > & {
                  requestForProposal?: Types.Maybe<
                    { __typename?: 'RequestForProposal' } & Pick<
                      Types.IRequestForProposal,
                      'id' | 'googleSheetsUrl' | 'salesforceRfpId' | 'auditWorkspace'
                    >
                  >
                }
            }
        }
    >
    shipperRateShipperFacilities: Array<
      { __typename?: 'ShipperRateShipperFacility' } & Pick<
        Types.IShipperRateShipperFacility,
        'id' | 'stopType'
      > & {
          shipperFacility: { __typename?: 'ShipperFacility' } & Pick<
            Types.IShipperFacility,
            'id' | 'uuid'
          > & {
              facility: { __typename?: 'Facility' } & Pick<Types.IFacility, 'id' | 'name'> & {
                  location: { __typename?: 'Location' } & Pick<
                    Types.ILocation,
                    'id' | 'address' | 'city' | 'stateCode' | 'zipcode'
                  >
                }
              hours: Array<
                { __typename?: 'FacilityScheduleHour' } & Pick<
                  Types.IFacilityScheduleHour,
                  'id' | 'closed' | 'day' | 'endTime' | 'startTime' | 'stopType' | 'unloadType'
                >
              >
            }
        }
    >
    carrierSalesRep?: Types.Maybe<{ __typename?: 'User' } & Pick<Types.IUser, 'id' | 'fullName'>>
    deliveryLocation?: Types.Maybe<
      { __typename?: 'Location' } & Pick<Types.ILocation, 'id' | 'city' | 'stateCode'>
    >
    equipment?: Types.Maybe<
      { __typename?: 'Equipment' } & Pick<Types.IEquipment, 'id' | 'key' | 'name' | 'parentKey'> & {
          parent?: Types.Maybe<{ __typename?: 'Equipment' } & Pick<Types.IEquipment, 'id'>>
        }
    >
    pickupLocation?: Types.Maybe<
      { __typename?: 'Location' } & Pick<Types.ILocation, 'id' | 'city' | 'stateCode'>
    >
    shipperApplication: { __typename?: 'ShipperApplication' } & Pick<
      Types.IShipperApplication,
      'id' | 'name'
    >
  }

export const AwardedLaneFragmentDoc = gql`
  fragment AwardedLane on ShipperRate {
    ...AwardedLaneListItem
    id
    carrierMarketRate
    datMiles
    listingDetails {
      id
      commodity
      maxWeight
      minWeight
      note
      offerLeadTime
    }
    rate {
      id
      amount
      rateTypeKey
    }
    requestForProposalLaneFeedback {
      id
      tttAtAward
      requestForProposalLanePrice {
        id
        tfxhAllIn
        requestForProposalLane {
          id
          requestForProposal {
            id
            googleSheetsUrl
            salesforceRfpId
            auditWorkspace
          }
        }
      }
    }
    shipperLaneId
    shipperRateShipperFacilities {
      id
      stopType
      shipperFacility {
        id
        uuid
        facility {
          id
          name
          location {
            id
            address
            city
            stateCode
            zipcode
          }
        }
        hours {
          id
          closed
          day
          endTime
          startTime
          stopType
          unloadType
        }
      }
    }
    volume
    volumeType
  }
  ${AwardedLaneListItemFragmentDoc}
`
